import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { queryClient } from "./configs/query/queryConfig";

import { GrowThemeProvider } from "./configs/theme/GrowThemeProvider";
import { LocalThemeProvider } from "./configs/theme/LocalThemeProvider";
import "./index.css";
import { logRocket } from "./lib/error-monitor/logrocket";
import { errorMonitor } from "./lib/error-monitor/sentry/errorMonitor";
import { QueryProvider } from "./providers/queryProvider";
import { StoreProvider } from "./providers/storeProvider";
errorMonitor.init();
logRocket.init();
logRocket.logSessionURL();
ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <StoreProvider>
      <GrowThemeProvider>
        <LocalThemeProvider>
          <QueryProvider client={queryClient}>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </QueryProvider>
        </LocalThemeProvider>
      </GrowThemeProvider>
    </StoreProvider>
  </React.StrictMode>
);
